<template>
    <v-container class="pa-0" v-if="confirmation.headline && confirmation.description">
        <v-card tile flat class="px-6 py-12">
            <h1 class="headline font-weight-bold mb-4">
                {{ $vuetify.lang.t(confirmation.headline) }}
            </h1>
            <div class="body-1 mb-4" v-html="$vuetify.lang.t(confirmation.description)">
            </div>
            <v-btn block color="primary darken-1"
                :to="buttonUrl">
                {{ $vuetify.lang.t('$vuetify.buttons.back_to_login') }}
            </v-btn>
        </v-card>
    </v-container>
</template>
<script>
    // 3rd
    import { mapGetters } from 'vuex';

    // utils
    import { ROUTE_LOGIN } from '../../utils/constants';
    import { setPageTitle } from '../../utils/helper';

    export default {
        name: 'auth-confirmation',
        computed: {
            ...mapGetters('confirmation', [
                'confirmation',
            ]),
            buttonUrl() {
                return { name: ROUTE_LOGIN };
            },
        },
    }
</script>
